
export default {
    Number_Whatsapp:"2389929063",
    URL_API:"https://admin.lojarc.shop/api"
}
